import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

const URL = '../assets/data.json';

@Injectable({
  providedIn: 'root'
})
export class AppglobalService {
  public oldUrl:string  = "https://api-easyhome.destiny-innovation.com/v1/web/app_dev.php/";
  public ApiUrl:string = "https://api-easyhome.destiny-innovation.com/v2/public/";


  public slidervideo =[
    {src: "https://mdbootstrap.com/img/video/Tropical.mp4", type:"video/mp4", titre: "Video une", description: "We'll Defeat Coronavirus!"},
    {src: "https://mdbootstrap.com/img/video/forest.mp4", type:"video/mp4", titre: "Video deux", description: "We'll Defeat Coronavirus!"},
    {src: "https://mdbootstrap.com/img/video/Tropical.mp4", type:"video/mp4", titre: "Video trois", description: "We'll Defeat Coronavirus!"},
    {src: "https://mdbootstrap.com/img/video/forest.mp4", type:"video/mp4", titre: "Video quatre", description: "We'll Defeat Coronavirus!"},
    {src: "https://mdbootstrap.com/img/video/Tropical.mp4", type:"video/mp4", titre: "Video cinq", description: "We'll Defeat Coronavirus!"},
    {src: "https://mdbootstrap.com/img/video/forest.mp4", type:"video/mp4", titre: "Video six", description: "We'll Defeat Coronavirus!"}
    
  ];
  Categories = [
    {
      id:1, nomcat:"CATEGORY_NAMES.LOGEMENTS", chemin:'categories/', imgcat:'./assets/img/categories/logement.jpg',
      subcat:[{id:1, sub: "Chambre"}, {id:2, sub: "Studio"}, {id:3, sub: "Appartement"}, {id:4, sub: "Villa"}]
    },
    {id:2, nomcat:"CATEGORY_NAMES.BUREAUX", chemin:'categories/',imgcat:'./assets/img/categories/bureau.jpg',
    subcat:[{id:1, sub: "01 Pièce"}, {id:2, sub: "02 Pièces"}, {id:3,sub: "03 Pièces"}, {id:4, sub: "+de 4 Pièces"}]
  },
    {id:3, nomcat:"CATEGORY_NAMES.ESPACES_MEUBLES", chemin:'categories/',imgcat:'./assets/img/categories/meuble.jpg',
    subcat:[{id:1, sub: "Chambre Meublée"}, {id:2, sub: "Studio Meublé"}, {id:3,sub: "Appartement Meublés"}, {id:4,sub: "Villa Meubléé"}]
  },
    {id:4, nomcat:"CATEGORY_NAMES.ESPACES_COMMERCIAUX", chemin:'categories/',imgcat:'./assets/img/categories/magasin.jpeg',
    subcat:[{id:1, sub: "Boutique"}, {id:2, sub: "Magasin"}, {id:3, sub: "Villa"}]
  },
    {id:5, nomcat:"CATEGORY_NAMES.SALLES_FETES", chemin:'categories/',imgcat:'./assets/img/categories/sallefete.jpg',
    subcat:[{id:1, sub: "Simple"}, {id:2, sub: "avec Climatiseur"}, {id:3,sub: "avec Couverts"}, {id:4, sub: "avec Traiteur"}]
  },
    {id:6, nomcat:"CATEGORY_NAMES.TERRAINS", chemin:'categories/',imgcat:'./assets/img/categories/terrain1.jpg',
    subcat:[{id:1,sub: "non titré"}, {id:2,sub: "Titré"}, {id:3, sub: "Lotis"},]
  },
    {id:7, nomcat:"CATEGORY_NAMES.GARAGES", chemin:'categories/',imgcat:'./assets/img/categories/garage2.jpg',
    subcat:[{id:1,sub: "Parking"}, {id:2, sub: "Réparation"}, {id:3, sub: "Vidange"}]
  },
  ];


  public Partenaires = [
    {id:1, nom:"ENSP Yaoundé", site:"https://polytechnique.cm/", logo:"./assets/img/partner/polytechnique.png"},
    {id:2, nom:"Technipole SubValor", site:"https://www.facebook.com/Technipolesupvalor1/", logo:"./assets/img/partner/technipole.jpg"},
    {id:3, nom:"Destiny Sarl", site:"https://www.destiny-innovation.com", logo:"./assets/img/partner/destiny.png"}
 
  ];

  Cathegories =[
    {id:1, classicon :"flaticon-home-plan",img:"assets/img/cathegories/img1.jpg", titre: "Des Habitations", description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor"},
    {id:2, classicon :"flaticon-hand-wash",img:"assets/img/cathegories/img2.jpg", titre: "Des Espaces Commerciaux", description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor"},
 ];
  public urlimg="assets/img/cathegories/img1.jpg";
    Newproprietes =[
      {id:1, nature: "maison", url:"/products-details", nom:"Chambre Moderne", prix: "20000", img:"assets/img/img_1.jpg"},
      {id:2, nature: "magasin", url:"/products-details", nom:"Chambre Moderne", prix: "20000", img:"assets/img/stats/magasin.png"},
      {id:12, nature: "garage", url:"/products-details", nom:"Chambre Moderne", prix: "20000", img:"assets/img/stats/garage.jpg"},
    ];
    Newmaison =[];
    Newmagasin =[];
    Newterrain =[];
    Newgarage =[];
    public count=0;
    msg ="Cliquez pour plus de détails statistiques !!!!";
    msgvue:boolean=false;

  serviceclient={
    nom:"easyHome Emmergency",
    pays:"Cameroun",
    indicepays:"+237",
    phone:"+237676006736"
  };
  Agents = [
    {id:1, noms:"L. DA VINCY", img:"./assets/img/agent/agent-1.jpg", ville:"Sangmelima-CMR", zone: "Mokolo elobi", social:"neds",},
    {id:1, noms:"THORES", img:"./assets/img/agent/agent-2.jpg", ville:"Yaoundé-CMR", zone: "Mokolo elobi" , social:"neds",},
    ];
    public  MenuVilles = [
      {
          "idville": 3,
          "nomville": "Bafoussam",
          "descriptionville": "Ouest",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531163632822287-bafoussamok.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2020-10-11T00:00:00+02:00"
      },
      {
          "idville": 4,
          "nomville": "Bertoua",
          "descriptionville": "Est",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531161153890219-bertoua1.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2021-02-11T00:00:00+01:00"
      },
      {
          "idville": 2,
          "nomville": "Douala",
          "descriptionville": "Littoral",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531162032677246-douala3.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2020-10-11T00:00:00+02:00"
      },
      {
          "idville": 5,
          "nomville": "Ebolowa",
          "descriptionville": "Sud",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531165651637776-ebolowa2.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2021-02-23T00:00:00+01:00"
      },
      {
          "idville": 8,
          "nomville": "Garoua",
          "descriptionville": "Nord",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531160442989346-garoua3.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2021-04-08T00:00:00+02:00"
      },
      {
          "idville": 7,
          "nomville": "Maroua",
          "descriptionville": "Extrême-Nord",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531155710497650-maroua1.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2021-04-08T00:00:00+02:00"
      },
      {
          "idville": 6,
          "nomville": "Ngaoundéré",
          "descriptionville": "Adamaoua",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531153831834871-ngoundere2.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2021-02-26T00:00:00+01:00"
      },
      {
          "idville": 1,
          "nomville": "Yaoundé",
          "descriptionville": "Centre",
          "photoville": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531154037677578-yaounde2.jpg",
          "activated": true,
          "deleted": false,
          "updated": false,
          "dateajout": "2020-10-11T00:00:00+02:00"
      }
  ];
  MenuMeubles = [
    {
        "idtypelogement": 29,
        "nomtypelogement": "Chambre meublée",
        "descriptiontypelogement": "Chambre meublée",
        "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603160027202261-appartement.jpg",
        "activated": true,
        "deleted": false,
        "updated": false,
        "dateajout": "2023-06-03T00:00:00+02:00",
        "categorie": null
    },
    {
        "idtypelogement": 30,
        "nomtypelogement": "Studio meublé",
        "descriptiontypelogement": "Studio meublé",
        "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603160114062579-appartement.jpg",
        "activated": true,
        "deleted": false,
        "updated": false,
        "dateajout": "2023-06-03T00:00:00+02:00",
        "categorie": null
    },
    {
        "idtypelogement": 31,
        "nomtypelogement": "Appartement meublé",
        "descriptiontypelogement": "Appartement meublé",
        "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603160145845673-appartement.jpg",
        "activated": true,
        "deleted": false,
        "updated": false,
        "dateajout": "2023-06-03T00:00:00+02:00",
        "categorie": null
    },
    {
        "idtypelogement": 32,
        "nomtypelogement": "Penthouse meublé",
        "descriptiontypelogement": "Penthouse meublé",
        "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603160241809765-appartement.jpg",
        "activated": true,
        "deleted": false,
        "updated": false,
        "dateajout": "2023-06-03T00:00:00+02:00",
        "categorie": null
    },
    {
        "idtypelogement": 33,
        "nomtypelogement": "Duplex meublé",
        "descriptiontypelogement": "Duplex meublé",
        "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603160327253629-appartement.jpg",
        "activated": true,
        "deleted": false,
        "updated": false,
        "dateajout": "2023-06-03T00:00:00+02:00",
        "categorie": null
    },
    {
        "idtypelogement": 34,
        "nomtypelogement": "Triplex meublé",
        "descriptiontypelogement": "Triplex meublé",
        "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603160404882208-appartement.jpg",
        "activated": true,
        "deleted": false,
        "updated": false,
        "dateajout": "2023-06-03T00:00:00+02:00",
        "categorie": null
    }
]

  public MenuProperties: any[] = [
    {
      "idcategorie": 1,
      "nomcategorie": "Habitation",
      "descriptioncategorie": "HABITATION",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/img/habitationv.png",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-10-09T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'activity-outline'
    },
    {
      "idcategorie": 9,
      "nomcategorie": "Bâtiments industriels",
      "descriptioncategorie": "Bâtiment industriel",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230531154345932997-batimentsidustriel.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2023-05-30T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'globe-outline'
    },
    {
      "idcategorie": 2,
      "nomcategorie": "Bureaux",
      "descriptioncategorie": "bureau modaine",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/v1/web/images/20210219193454000000-bureau.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-10-09T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'cloud-download-outline'
    },
    {
      "idcategorie": 3,
      "nomcategorie": "Espace commercial",
      "descriptioncategorie": "CENTRE COMMERCIAL",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/img/centre_commercial.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-10-09T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'shopping-cart-outline'
    },
    {
      "idcategorie": 4,
      "nomcategorie": "Espace meublé",
      "descriptioncategorie": "ESPACE MEUBLE",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/img/espace_meuble.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-10-09T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'copy-outline'
    },
    {
      "idcategorie": 5,
      "nomcategorie": "Parking",
      "descriptioncategorie": "PARKING",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/img/parking.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-10-09T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'car-outline'
    },
    {
      "idcategorie": 6,
      "nomcategorie": "Salles d'événements",
      "descriptioncategorie": "SALLE DE FETE",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/img/sallefete.png",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-10-12T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'archive-outline'
    },
    {
      "idcategorie": 7,
      "nomcategorie": "Terrains",
      "descriptioncategorie": "TERRAIN",
      "photocategorie": "http://api-easyhome.destiny-innovation.com/img/terrain.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-10-12T00:00:00+02:00",
      "typeslogement": [],
      "icon": 'map-outline'
    }
  ];

  public MenuLogements: any[] = [
    {
      "idtypelogement": 1,
      "nomtypelogement": "Chambre",
      "descriptiontypelogement": "Maison à une pièce avec eventuellement une cuisine et une douche",
      "phototypelogement": "ddddddddd",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-11-21T00:00:00+01:00",
      "categorie": null,
      "icon": 'home-outline'
    },
    {
      "idtypelogement": 2,
      "nomtypelogement": "Studio",
      "descriptiontypelogement": "Studio",
      "phototypelogement": "ddddddddd",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-11-21T00:00:00+01:00",
      "categorie": null,
      "icon": 'home-outline'
    },
    {
      "idtypelogement": 3,
      "nomtypelogement": "Appartement",
      "descriptiontypelogement": "Appartement",
      "phototypelogement": "ddddddddd",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2020-11-21T00:00:00+01:00",
      "categorie": null,
      "icon": 'home-outline'
    },
    {
      "idtypelogement": 10,
      "nomtypelogement": "Duplex",
      "descriptiontypelogement": "Duplex",
      "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603153514515094-appartement.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2023-06-03T00:00:00+02:00",
      "categorie": null,
      "icon": 'home-outline'
    },
    {
      "idtypelogement": 12,
      "nomtypelogement": "Villa",
      "descriptiontypelogement": "Villas",
      "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603153701742718-appartement.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2023-06-03T00:00:00+02:00",
      "categorie": null,
      "icon": 'home-outline'
    },
    {
      "idtypelogement": 15,
      "nomtypelogement": "Château",
      "descriptiontypelogement": "Château",
      "phototypelogement": "http://api-easyhome.destiny-innovation.com/v1/web/images/20230603153902911420-appartement.jpg",
      "activated": true,
      "deleted": false,
      "updated": false,
      "dateajout": "2023-06-03T00:00:00+02:00",
      "categorie": null,
      "icon": 'home-outline'
    }
  ];

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) { }

  /**
   * Translates a category name using the translation keys defined in the translation files
   * @param categoryName The original category name to translate
   * @returns The translated category name or the original name if no translation is found
   */
  getTranslatedCategoryName(categoryName: string): string {
    const categoryMap: { [key: string]: string } = {
      'Habitation': 'CATEGORY_NAMES.HABITATION',
      'Bâtiments industriels': 'CATEGORY_NAMES.BATIMENTS_INDUSTRIELS',
      'Bureaux': 'CATEGORY_NAMES.BUREAUX',
      'Espace commercial': 'CATEGORY_NAMES.ESPACE_COMMERCIAL',
      'Espace meublé': 'CATEGORY_NAMES.ESPACE_MEUBLE',
      'Parking': 'CATEGORY_NAMES.PARKING',
      'Salles d\'événements': 'CATEGORY_NAMES.SALLES_EVENEMENTS',
      'Terrains': 'CATEGORY_NAMES.TERRAINS',
      'Garages': 'CATEGORY_NAMES.GARAGES'
    };

    const translationKey = categoryMap[categoryName];
    if (translationKey) {
      return this.translate.instant(translationKey);
    }
    return categoryName;
  }

  getTranslatedPropertyType(propertyType: string): string {
    if (!propertyType) return '';
    
    // Map des types de propriétés vers leurs clés de traduction
    const propertyTypeMap: { [key: string]: string } = {
      'Appartement': 'PROPERTY_TYPES.APPARTEMENT',
      'Appartement meublé': 'PROPERTY_TYPES.APPARTEMENT_MEUBLE',
      'Atelier': 'PROPERTY_TYPES.ATELIER',
      'Boutique': 'PROPERTY_TYPES.BOUTIQUE',
      'Box Marché': 'PROPERTY_TYPES.BOX_MARCHE',
      'Bureaux partagés': 'PROPERTY_TYPES.BUREAUX_PARTAGES',
      'Bureaux privés': 'PROPERTY_TYPES.BUREAUX_PRIVES',
      'Centre commercial': 'PROPERTY_TYPES.CENTRE_COMMERCIAL',
      'Centre de distribution': 'PROPERTY_TYPES.CENTRE_DISTRIBUTION',
      'Chalet': 'PROPERTY_TYPES.CHALET',
      'Chambre': 'PROPERTY_TYPES.CHAMBRE',
      'Chambre meublée': 'PROPERTY_TYPES.CHAMBRE_MEUBLEE',
      'Château': 'PROPERTY_TYPES.CHATEAU',
      'Duplex': 'PROPERTY_TYPES.DUPLEX',
      'Duplex meublé': 'PROPERTY_TYPES.DUPLEX_MEUBLE',
      'Entrepôt': 'PROPERTY_TYPES.ENTREPOT',
      'Espaces de coworking': 'PROPERTY_TYPES.ESPACES_COWORKING',
      'Ferme': 'PROPERTY_TYPES.FERME',
      'Hôpital': 'PROPERTY_TYPES.HOPITAL',
      'Immeuble commercial': 'PROPERTY_TYPES.IMMEUBLE_COMMERCIAL',
      'Immeuble industriel': 'PROPERTY_TYPES.IMMEUBLE_INDUSTRIEL',
      'Magasin': 'PROPERTY_TYPES.MAGASIN',
      'Manoir': 'PROPERTY_TYPES.MANOIR',
      'Penthouse': 'PROPERTY_TYPES.PENTHOUSE',
      'Penthouse meublé': 'PROPERTY_TYPES.PENTHOUSE_MEUBLE',
      'Salle de cinéma': 'PROPERTY_TYPES.SALLE_CINEMA',
      'Salle de concert': 'PROPERTY_TYPES.SALLE_CONCERT',
      'Salle de congrès': 'PROPERTY_TYPES.SALLE_CONGRES',
      'Salle de fête': 'PROPERTY_TYPES.SALLE_FETE',
      'Studio': 'PROPERTY_TYPES.STUDIO',
      'Studio meublé': 'PROPERTY_TYPES.STUDIO_MEUBLE',
      'Terrain agricole': 'PROPERTY_TYPES.TERRAIN_AGRICOLE',
      'Terrain bâti': 'PROPERTY_TYPES.TERRAIN_BATI',
      'Terrain en diffus': 'PROPERTY_TYPES.TERRAIN_DIFFUS',
      'Terrain en lotissement': 'PROPERTY_TYPES.TERRAIN_LOTISSEMENT',
      'Terrain nu': 'PROPERTY_TYPES.TERRAIN_NU',
      'Triplex': 'PROPERTY_TYPES.TRIPLEX',
      'Triplex meublé': 'PROPERTY_TYPES.TRIPLEX_MEUBLE',
      'Usine': 'PROPERTY_TYPES.USINE',
      'Villa': 'PROPERTY_TYPES.VILLA',
      'École': 'PROPERTY_TYPES.ECOLE',
      'Épicerie': 'PROPERTY_TYPES.EPICERIE'
    };

    const translationKey = propertyTypeMap[propertyType];
    if (translationKey) {
      return this.translate.instant(translationKey);
    }
    return propertyType;
  }
}
